"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mockBannerComponentProps = void 0;
var _mockData = require("./mockData");
const mockBannerComponentProps = (layout)=>({
        banner: (0, _mockData.getDataForLayout)(layout),
        debug: true,
        modulePosition: 0
    });
exports.mockBannerComponentProps = mockBannerComponentProps;
